import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AddItemButton } from '@metto/ui-web/features/items';
import { Icon } from '@metto/ui-web/shared/components';
import AddButtonForm from './AddButtonForm';

export const AddButton = () => {
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <>
      <AddItemButton onClickButton={open}>
        <Icon name="plus" size={22} strokeWidth={1.4} />
      </AddItemButton>

      <Modal onClose={close} opened={opened} title="New Bookmark">
        <AddButtonForm close={close} />
      </Modal>
    </>
  );
};
